<template>
  <div>
    <div class="bank-box-frm">
      <van-form @submit="onSubmit">
        <van-field
          v-model="frm.bank_name"
          :label="$t('bank.bankName')"
          :placeholder="$t('bank.bankName')"
          :rules="[{ required: true, message: $t('bank.bankNameError') }]"
        />

        <van-field
          v-model="frm.card_name"
          :label="$t('bank.usrName')"
          :placeholder="$t('bank.usrName')"
          :rules="[{ required: true, message: $t('bank.usrNameError') }]"
        />

        <van-field
          v-model="frm.card_number"
          :label="$t('bank.cardCode')"
          :placeholder="$t('bank.cardCode')"
          :rules="[{ required: true, message: $t('bankcardCodeError') }]"
        />

        <div style="margin: 16px">
          <van-button round block type="info" native-type="submit" v-if="safeBtnShow">
            <van-loading v-if="posting" /><span v-else>{{
              frm.id ? $t("common.modify") : $t("common.binding")
            }}</span>
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "BankInfo",
  props: ["dataItem",'btnshow'],
  computed: {
    safeDataItem() {
      return this.dataItem || {};
    },
    safeBtnShow(){
      return this.btnshow || false
    }
  },
  watch:{
    dataItem(newVal){
      this.frm = newVal
    }
  },  
  data() {
    return {
      posting: false,
      frm: {
        id: null,
        bank_name: null,
        card_number: null,
        card_name: null,
      },
    };
  },
  methods: {
    async onSubmit() {
      if (this.posting) {
        return;
      }
      this.posting = true;
      await this.$http({
        method: "post",
        url: "setBank",
        data: this.frm,
      })
        .then((res) => {
          this.posting = false;
          this.$toast.success(res.msg);
          this.frm = {
            id: null,
            bank_name: null,
            card_number: null,
            card_name: null,
          };
          this.$emit('reset-data')
        })
        .catch(() => {
          this.posting = false;
        });
    },
  },
};
</script>

<style>
</style>
